import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase"; // adjust to your Firestore init path

const COLLECTION = "golfers";

/**
 * All golfers a lead golfer has previously added, so they can be reused
 * (selected, not retyped) on future bookings. This is what powers
 * "Select Existing Golfers" (SC2) and the combination flow (SC3).
 */
export async function getSavedGolfers(ownerId) {
  if (!ownerId) return [];
  const q = query(collection(db, COLLECTION), where("ownerId", "==", ownerId));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

/**
 * Saves a newly-entered golfer (SC1) under the lead golfer's account so it
 * shows up in getSavedGolfers() on their next booking. Returns the new
 * golfer's id — pass this back as the golfer's `id` in the roster so it's
 * recognized as "existing" going forward.
 */
export async function saveGolfer(ownerId, golfer) {
  const ref = await addDoc(collection(db, COLLECTION), {
    ownerId,
    name: golfer.name,
    passportNumber: golfer.passportNumber,
    phone: golfer.phone,
    email: golfer.email,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}

/**
 * Removes a saved golfer (golfing buddy) from the lead golfer's account —
 * used from the Profile > Golfing Buddies tab. Doesn't touch any past or
 * in-progress bookings, since the roster copies golfer fields at booking
 * time rather than referencing this doc.
 */
export async function deleteGolfer(id) {
  await deleteDoc(doc(db, COLLECTION, id));
}